var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	7359: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(2155).then(() => (() => (__webpack_require__(2155))))))),
	2192: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,11,4], () => (Promise.all([__webpack_require__.e(6905), __webpack_require__.e(7720)]).then(() => (() => (__webpack_require__(5339))))))),
	9963: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,11,5], () => (Promise.all([__webpack_require__.e(7685), __webpack_require__.e(2192)]).then(() => (() => (__webpack_require__(7685))))))),
	2369: () => (loadSingleton("default", "@monorepo/localization", false, () => (Promise.all([__webpack_require__.e(7737), __webpack_require__.e(968)]).then(() => (() => (__webpack_require__(8587))))))),
	7260: () => (loadSingleton("default", "@monorepo/theme-provider", false, () => (__webpack_require__.e(8952).then(() => (() => (__webpack_require__(6571))))))),
	5641: () => (loadSingleton("default", "@monorepo/store/useUserStore", false, () => (Promise.all([__webpack_require__.e(1154), __webpack_require__.e(4314)]).then(() => (() => (__webpack_require__(4314))))))),
	8991: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))))),
	1229: () => (loadSingleton("default", "@monorepo/maintenance", false, () => (__webpack_require__.e(1780).then(() => (() => (__webpack_require__(9399))))))),
	2707: () => (loadSingletonVersion("default", "@tanstack/react-query", false, [1,5,51,1], () => (__webpack_require__.e(4460).then(() => (() => (__webpack_require__(4460))))))),
	3139: () => (loadSingleton("default", "@monorepo/store/usePreferencesStore", false, () => (Promise.all([__webpack_require__.e(1154), __webpack_require__.e(7654)]).then(() => (() => (__webpack_require__(7654))))))),
	5542: () => (loadSingletonVersion("default", "react-router-dom", false, [1,6,30,3], () => (__webpack_require__.e(2179).then(() => (() => (__webpack_require__(2179))))))),
	5681: () => (loadSingletonVersion("default", "@unleash/proxy-client-react", false, [1,4,4,0], () => (Promise.all([__webpack_require__.e(8508), __webpack_require__.e(8070)]).then(() => (() => (__webpack_require__(5689))))))),
	1154: () => (loadSingletonVersion("default", "zustand", false, [1,4,5,2], () => (Promise.all([__webpack_require__.e(7359), __webpack_require__.e(472)]).then(() => (() => (__webpack_require__(472))))))),
	8533: () => (loadSingleton("default", "@monorepo/modal", false, () => (Promise.all([__webpack_require__.e(7530), __webpack_require__.e(2257), __webpack_require__.e(1154), __webpack_require__.e(5641), __webpack_require__.e(4297)]).then(() => (() => (__webpack_require__(6678))))))),
	8508: () => (loadSingletonVersion("default", "unleash-proxy-client", false, [1,3,6,1], () => (__webpack_require__.e(4418).then(() => (() => (__webpack_require__(4418))))))),
	596: () => (loadSingleton("default", "@monorepo/subpage-wrapper", false, () => (Promise.all([__webpack_require__.e(6905), __webpack_require__.e(8533), __webpack_require__.e(112)]).then(() => (() => (__webpack_require__(7731))))))),
	5710: () => (loadSingleton("default", "@monorepo/input-card", false, () => (Promise.all([__webpack_require__.e(6905), __webpack_require__.e(2257), __webpack_require__.e(3170)]).then(() => (() => (__webpack_require__(789)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"596": [
		596
	],
	"1154": [
		1154
	],
	"1852": [
		2369,
		7260
	],
	"2192": [
		2192
	],
	"5641": [
		5641
	],
	"7150": [
		1229,
		2707,
		3139,
		5542,
		5681
	],
	"7359": [
		7359
	],
	"8182": [
		5710
	],
	"8508": [
		8508
	],
	"8533": [
		8533
	],
	"8991": [
		8991
	],
	"9963": [
		9963
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}